/**
 * Product Slider Section JavaScript
 * Handles Swiper initialization, product card interactions, and add to cart functionality
 */

class ProductSlider {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = sectionElement.dataset.sectionId;
    this.variation = sectionElement.dataset.variation;
    this.backgroundSwiper = null;

    this.init();
  }

  init() {
    if (this.variation === 'product_slider') {
      this.initializeSwiper();
      this.bindCardClicks();
      this.syncContentToSlide(0);
    }

    this.bindAddToCartButtons();
  }

  initializeSwiper() {
    const swiperElement = this.section.querySelector(
      '[data-swiper-backgrounds]',
    );
    if (!swiperElement) return;

    const enableAutoplay = this.section.dataset.enableAutoplay === 'true';

    const swiperConfig = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 600,
      allowTouchMove: false,
      cssMode: false,
      on: {
        slideChange: () => {
          this.syncContentToSlide(this.backgroundSwiper.activeIndex);
        },
      },
    };

    // if (enableAutoplay) {
    //   swiperConfig.autoplay = {
    //     delay: 4000,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    //   };
    // }

    this.backgroundSwiper = new Swiper(swiperElement, swiperConfig);
  }

  syncContentToSlide(activeIndex) {
    // Update product cards
    const cards = this.section.querySelectorAll(
      '.section-product-slider__card',
    );
    cards.forEach((card, index) => {
      if (index === activeIndex) {
        card.classList.add('section-product-slider__card--active');
      } else {
        card.classList.remove('section-product-slider__card--active');
      }
    });

    // Update info panel
    const infoItems = this.section.querySelectorAll(
      '.section-product-slider__info-item',
    );
    infoItems.forEach((item, index) => {
      if (index === activeIndex) {
        item.classList.add('section-product-slider__info-item--active');
      } else {
        item.classList.remove('section-product-slider__info-item--active');
      }
    });
  }

  bindCardClicks() {
    // Prevent duplicate bindings
    if (this.section.dataset.cardClicksBound === 'true') return;
    this.section.dataset.cardClicksBound = 'true';

    const cardElements = this.section.querySelectorAll(
      '.section-product-slider__card',
    );

    cardElements.forEach((card, index) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        // Use background swiper to drive everything
        if (this.backgroundSwiper) {
          this.backgroundSwiper.slideTo(index);
        }
      });
    });
  }

  bindAddToCartButtons() {
    // Prevent duplicate bindings when sections re-initialize
    if (this.section.dataset.addToCartBound === 'true') return;
    this.section.dataset.addToCartBound = 'true';

    // Add to cart functionality - delegate to handle multiple buttons
    this.section.addEventListener('click', async (event) => {
      const addToCartButton = event.target.closest(
        '.section-product-slider__add-to-cart',
      );
      if (!addToCartButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantId = addToCartButton.getAttribute('data-variant-id');
      const productId = addToCartButton.getAttribute('data-product-id');

      if (!variantId || variantId === 'default') {
        console.error('No variant ID available for add to cart');
        return;
      }

      // Prevent multiple clicks while processing
      if (addToCartButton.classList.contains('loading')) {
        return;
      }

      // Set loading state
      addToCartButton.classList.add('loading');
      addToCartButton.setAttribute('aria-disabled', 'true');

      // Show spinner, hide cart icon
      const cartIcon = addToCartButton.querySelector('.add-to-cart-icon');
      const spinner = addToCartButton.querySelector('.add-to-cart-spinner');
      if (cartIcon) cartIcon.style.display = 'none';
      if (spinner) spinner.style.display = 'block';

      try {
        // Use the existing ajax cart functionality
        const sectionsToRender = window.ajaxCart
          ? window.ajaxCart.getSectionsToRender()
          : new Map();
        const sectionIds = Array.from(sectionsToRender.keys());

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (sectionIds.length > 0) {
          formData.append('sections', sectionIds);
        }

        console.log('adding to cart', variantId);

        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });

        if (response.ok) {
          // Open cart drawer using existing functionality
          if (window.ajaxCart && window.ajaxCart.toggleCartDrawer) {
            window.ajaxCart.toggleCartDrawer(true);
          }
        } else {
          console.error('Failed to add product to cart');
        }
      } catch (error) {
        console.error('Error adding product to cart:', error);
      } finally {
        // Remove loading state
        addToCartButton.classList.remove('loading');
        addToCartButton.setAttribute('aria-disabled', 'false');

        // Hide spinner, show cart icon
        const cartIcon = addToCartButton.querySelector('.add-to-cart-icon');
        const spinner = addToCartButton.querySelector('.add-to-cart-spinner');
        if (cartIcon) cartIcon.style.display = 'block';
        if (spinner) spinner.style.display = 'none';
      }
    });
  }
}

// Initialize all product slider sections when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  const productSliderSections = document.querySelectorAll(
    '.section-product-slider',
  );

  productSliderSections.forEach((section) => {
    // 1. Check if this section is already initialized
    if (section.getAttribute('data-slider-initialized') === 'true') {
      return; // Skip it if we already touched it
    }

    // 2. Mark it as initialized
    section.setAttribute('data-slider-initialized', 'true');

    // 3. Initialize the class
    new ProductSlider(section);
  });
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.section-product-slider');
    if (section) {
      new ProductSlider(section);
    }
  });
}
